import React, { useEffect, useState } from 'react';
import './../home.scss';
import './../trending.scss';
import Loading from '../../../components/Loading';
import { useContentLibraryManager } from "../../../hooks/useManagers";

const TrendingContent = () => {
  const contentMgr = useContentLibraryManager();
  const [trendingContent, setTrendingContent] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrendingContent = async () => {
      try {
        if (contentMgr) {
          const result = await contentMgr.TrendingContent();
          if (result.Success) {
            setTrendingContent(result);
          } else {
            setError('Failed to fetch trending content.');
          }
        }
      } catch (err) {
        setError(`Error fetching trending content: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendingContent();
  }, [contentMgr]);

  useEffect(() => {
    if (trendingContent) {
      const imageSet = trendingContent.Items?.slice(0, 3);
      setImages(imageSet);
    }
  }, [trendingContent]);

  const getFreeContentLink = (imageId) => {
    console.log('imageId:', imageId); 
    switch (imageId) {
      case 'e8b1f1ea-d178-42c6-b50d-1f871be141f6':
        return 'https://next.eepass.org/learningmodules/1ffc1043-8449-41e9-9fe0-ea36f4e967e9/story_html5.html';
      case '83d33b95-9e2e-4f12-8726-36573db5a270':
        return 'https://www.niet.org/newsroom/show/video/free-ee-pass-resource-video-8th-grade-english-lesson-full-lesson';
      case '32a0ea8e-ace9-4e7d-8054-336baf70d7b5':
        return 'https://www.niet.org/newsroom/show/video/free-ee-pass-resource-video-elementary-cluster-meeting-full-meeting';
      default:
        return null;
    }
  }

  return (
    <div className='trending-content'>
      <div className='trending-content-header'>
        {/* Trending EE PASS Content */}
        Explore Our Coaching Hub
      </div>
      {loading ? (
        <div className='loading-icon-container'>
          <Loading size={'2.25rem'} />
        </div>
      ) : error ? (
        <div className='error-message'>
          {error}
        </div>
      ) : (
        <div className="trending-img-container">
          {images.map((image) => {
              var link = getFreeContentLink(image.Id);
              return link ? (
              <div key={image.Id} className='img-div-header'>
                <a href={link} target="_blank" rel="noopener noreferrer">
                <img src={image.ThumbnailFile?.FileUrl} alt={`${image.Title}`} />
                <div className='trending-img-title'>{image.Title}</div>
                </a>
              </div>
              ) : (
              <div key={image.Id} className='img-div-header'>
                <img src={image.ThumbnailFile?.FileUrl} alt={`${image.Title}`} />
                <div className='trending-img-title'>{image.Title}</div>
              </div>
              )
            }
          )}
        </div>
      )}
    </div>
  );
};

export default TrendingContent;
